module.exports = "https://static.energy5.com/_next/static/images/perfect3-b7af0d0db8812cfba06e977a74b22968.png";